export enum CondominiumType {
  Residential = 'residential',
  Commercial = 'commercial',
}

export default CondominiumType;
